(() => {
  if (window.GuideLightStickyCartLoaded) return;
  window.GuideLightStickyCartLoaded = true;

  const selector = '[data-guidelight-sticky-cart]';
  const controllers = new WeakMap();

  const matchingRoots = (scope) => {
    const roots = [];
    if (scope?.matches?.(selector)) roots.push(scope);
    scope?.querySelectorAll?.(selector).forEach((root) => roots.push(root));
    return roots;
  };

  const initRoot = (root) => {
    if (!root || controllers.has(root)) return;

    const threshold = Number(root.dataset.showAfter || 700);
    const configuredLabel = root.dataset.buttonLabel || 'Add to cart';
    let frame = null;

    const updateVisibility = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        root.classList.toggle('is-visible', window.scrollY >= threshold);
        frame = null;
      });
    };

    const updateVariant = (event) => {
      const detail = event.detail || {};
      if (detail.productHandle !== root.dataset.productHandle) return;

      const idInput = root.querySelector('[data-guidelight-sticky-variant-id]');
      const price = root.querySelector('[data-guidelight-sticky-price]');
      const variant = root.querySelector('[data-guidelight-sticky-variant]');
      const button = root.querySelector('[data-guidelight-sticky-add]');
      const buttonLabel = root.querySelector('[data-guidelight-sticky-add-label]');

      if (idInput) idInput.value = detail.variantId;
      if (price) price.textContent = detail.formattedPrice || '';
      if (variant) variant.textContent = detail.variantTitle || '';
      if (button) button.disabled = !detail.available;
      if (buttonLabel) buttonLabel.textContent = detail.available ? configuredLabel : 'Sold out';
    };

    const cleanup = () => {
      window.removeEventListener('scroll', updateVisibility);
      document.removeEventListener('guidelight:variant-change', updateVariant);
      if (frame) window.cancelAnimationFrame(frame);
      controllers.delete(root);
    };

    controllers.set(root, { cleanup });
    root.dataset.guidelightInitialized = 'true';
    window.addEventListener('scroll', updateVisibility, { passive: true });
    document.addEventListener('guidelight:variant-change', updateVariant);
    updateVisibility();
  };

  const init = (scope = document) => matchingRoots(scope).forEach(initRoot);
  const unload = (scope) => matchingRoots(scope).forEach((root) => controllers.get(root)?.cleanup());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    matchingRoots(event.target).forEach((root) => root.classList.add('is-visible'));
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    matchingRoots(event.target).forEach((root) => {
      root.classList.toggle('is-visible', window.scrollY >= Number(root.dataset.showAfter || 700));
    });
  });
})();
